import React, { useState } from 'react';
import { connect } from 'react-redux';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReportTab from '../ReportTab';
import BtnRefresh from '../buttons/BtnRefresh';
import BtnExpand from '../buttons/BtnExpand';
import RptMultiTotal from './views/RptMultiTotal';
import { Collapse } from 'bootstrap';

import { errorMessage, onlyUnique, cmp, deptName, sdpName, rptTotalQty, rptTotal } from '../functions';

const mapStateToProps = (state) => {
        return {
		apiServer: state.apiServer,
		agent: state.agent,
		uid: state.uid,
		session: state.session,
        periodType: state.periodType,
        periodDateStart: state.periodDateStart,
        periodDateEnd: state.periodDateEnd,
        dept_tab: state.dept_tab,
        tlz_tab: state.tlz_tab
    }
}

const mapDispatchToProps = { errorMessage }

function RptSubDeptByDept(props){
	const [rpt_sub, setRptSub] = useState([]);
    const [isLoading,setIsLoading] = useState(false);

	const refresh = () => {
		setIsLoading(true);

		var F1031 = props.periodType;
		var F254 = props.periodDateStart;

		// logging needed
		fetch(props.apiServer+'?uid='+props.uid+'&session='+props.session+'&action=rpt_sub&agent='+props.agent+'&F1031='+F1031+'&F1034=3&F254='+F254)
		.then(response => response.json())
		.then(result => {
			// logging needed
			if(result.data){
				setRptSub(result.data);
                setIsLoading(false);
                let collapsible = document.getElementById('collapse_SubDeptByDept');
                if(!collapsible.classList.contains("show")){            
                    new Collapse(document.getElementById('collapse_SubDeptByDept'));
                }                
			}
			else{
				props.errorMessage("Error retrieving rpt_sub data: "+result.message);
                setIsLoading(false);
			}
		});
	}

	

	let rptData = rpt_sub.map(record => record.F03).filter(onlyUnique).map(dept => {
		return ({
			description: deptName(rpt_sub,dept),
			total: rptTotal(rpt_sub.filter((record) => record.F03 === dept), 3),
			data: rpt_sub.filter((data) => data.F03 === dept).sort(function (a, b) {
				return cmp(a.F04,b.F04)
			}).map((record) => record.F04).filter(onlyUnique).map((sdp) => {
				return ({
					code: sdp,
					description: sdpName(rpt_sub, sdp),
					qty: rptTotalQty(rpt_sub.filter((record) => record.F04 === sdp), 3),
					dollars: rptTotal(rpt_sub.filter((record) => record.F04 === sdp), 3)
				});
			})
		});
	});

	return (
		<ReportTab id='SubDeptByDept'>
			<ReportTab.Header parentId='SubDeptByDept' title='Sub-dept. By Dept.'>
				<BtnRefresh parentId='SubDeptByDept' loading={isLoading} action={refresh} />
				<BtnExpand parentId='SubDeptByDept' action={refresh} />
			</ReportTab.Header>
			<ReportTab.Expand parentId='SubDeptByDept'>
				<RptMultiTotal data={rptData} />
			</ReportTab.Expand>
		</ReportTab>
	);
}

export default connect(
        mapStateToProps,
        mapDispatchToProps
)(RptSubDeptByDept);

